<template>
  <div>
    <div
      style="height: 100dvh; background: #e9ecef"
      class="bluebtn position-relative"
    >
      <div class="h-100">
        <div class="page-head-mob p-3" style="height: 60px">
          <img
            @click="goBackMobile"
            class="mr-3 mb-1 pointer"
            src="../../assets/panelLog/mob-design/bck-arr-mob-head.svg"
            alt=""
          />Resume Screening
        </div>
        <div class="resscreening-innercontainer">
          <section class="h-100 w-100">
            <div
              class="
                pb-3
                d-flex
                align-items-center
                justify-content-between
                w-100
              "
            >
              <div class="position-relative mob-search-pan" style="width: 90%">
                <b-form-input
                  class="w-100"
                  type="search"
                  placeholder="Search Candidates"
                  v-model.trim="searchQuery"
                  debounce="500"
                  @update="searchPanel"
                >
                </b-form-input>
                <img
                  style="position: absolute; top: 8px; left: 13px"
                  src="../../assets/panelMob/magni.svg"
                  alt=""
                />
              </div>
              <img
                @click="showfiltercard = !showfiltercard"
                src="../../assets/panelLog/mob-design/wfil-bbg.svg"
                alt=""
              />
            </div>
            <PanelMobileShimmer v-if="LoaderStatus" />
            <div
              v-else-if="screeningCandidates.length == 0 && searchQuery != ''"
              class="
                h-90
                w-100
                d-flex
                align-items-center
                justify-content-center
                flex-column
              "
            >
              <div class="">
                <img
                  src="../../assets/panelLog/mob-design/nosearch-scfp-dat.svg"
                />
              </div>
              <div class="noscfp-data-txt mt-3 text-break">
                No matching results for '{{ searchQuery }}'.
              </div>
            </div>
            <div
              class="
                h-100
                w-100
                d-flex
                align-items-center
                justify-content-center
                flex-column
              "
              v-else-if="screeningCandidates.length === 0 && !searchQuery"
            >
              <img src="@/assets/New-imgs/switch/screeningempty.svg" alt="" />
              <div class="mobres-empty-txt">
                There is no interview resume screenings assigned
              </div>
            </div>
            <div v-else style="height: 92%">
              <section
                class="overflow-auto pr-1 h-100"
                @scroll="onScrollScreening"
              >
                <div class="mobrs-card d-flex flex-column w-100 gap-15">
                  <b-card
                    v-for="(cand, index) in screeningCandidates"
                    :key="index"
                    :id="index + 'top'"
                  >
                    <section class="d-flex flex-column w-100 gap-5">
                      <div class="mobrs-card-heads text-truncate">
                        {{ cand.candidate.name }}
                      </div>
                      <div class="mobrs-card-heads text-truncate">
                        {{ cand.candidate.email }}
                      </div>
                      <div class="mobrs-card-heads">
                        {{ cand.candidate.phoneNumber }}
                      </div>
                    </section>
                    <section class="mt-2">
                      <div
                        class="color-3a3c40 mobrs-card-heads mob-fs-11 mob-fw-"
                      >
                        Job Name
                      </div>
                      <div class="mobrs-card-heads text-truncate">
                        {{ cand.jobID ? cand.jobData.title : "-" }}
                      </div>
                    </section>
                    <div
                      @click.stop="navigateToLink(cand)"
                      class="addpan mt-2 w-100"
                    >
                      <b-button
                        class="btn-txt-mob btn-mob-size w-100"
                        @click="
                          $router.push({
                            name: 'GiveFeedback',
                            params: { id: cand._id },
                            query: {
                              candidateId: cand.candidateID,
                            },
                          })
                        "
                      >
                        <span class="addpantxt">{{
                          !cand.submitted ? "Give Feedback" : "View Feedback"
                        }}</span>
                      </b-button>
                    </div>
                  </b-card>
                  <b-overlay
                    class="mt-4"
                    :show="showLoader"
                    rounded="sm"
                  ></b-overlay>
                </div>
              </section>
            </div>
          </section>
        </div>
      </div>
    </div>
    <b-modal
      hide-footer
      hide-header
      id="panelfiltermodal"
      modal-class="bottom-modal"
      :visible="showfiltercard"
      no-close-on-backdrop
      @hidden="showfiltercard = false"
    >
      <div class="text-center filter-box-head">Filters</div>
      <div class="position-relative">
        <selectCustom
          placeholder="Status"
          label="Status"
          :dropdown="true"
          :values="status"
          :vmodel="filterStatus"
          type="filter"
          @select-value="(data) => (filterStatus = data)"
        />
      </div>
      <div
        class="d-flex justify-content-between align-items-center bluebtn mt-3"
      >
        <b-button class="acs-cancelBtn-filter" @click="showfiltercard = false">
          Cancel
        </b-button>

        <div class="d-flex">
          <b-button class="acs-cancelBtn-filter mr-2" @click="clear">
            Reset
          </b-button>
          <b-button class="pointer acs-cancelBtn-filter" @click="applyFilter">
            Apply
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import PanelMobileShimmer from "../../components/fixedcomponents/PanelMobileShimmer.vue";
import SelectCustom from "@/components/InputComponents/SelectCustom.vue";
import screeningMixin from "./screeningMixin";
export default {
  mixins: [screeningMixin],
  data() {
    return {
      searchQuery: "",
      noofcards: 10,
      showfiltercard: false,
    };
  },
  components: {
    SelectCustom,
    PanelMobileShimmer,
  },
  created() {
    this.LoaderStatus = true;
    this.fetchScreeningData();
  },
};
</script>

<style>
.h-80 {
  height: 80%;
}
.mobrs-main-container {
  background: #ffffff;
  border-radius: 4px;
}
.mobres-empty-txt {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 11px;
  color: #344054;
}
.mobrs-card .card {
  height: 160px;
  width: 100%;
  background: #ffffff;
  border: 1px solid rgba(140, 140, 140, 0.33);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
  border-radius: 8px;
}
.mobrs-card .card-body {
  padding: 10px;
}
.mobrs-card-heads {
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: 12px;
  color: #343434;
}
.mob-fs-11 {
  font-size: 11px !important;
}
.mob-fw-500 {
  font-weight: 500 !important;
}
.color-3a3c40 {
  color: #3a3c40;
}
.gap-5 {
  gap: 5px;
}

.bottom-modal .modal-dialog {
  position: fixed;
  bottom: 0;
  margin: 0;
  max-width: 100%;
  width: 100%;
  transition: bottom 0.5s ease;
}
.selectCustom-dropdown {
  position: unset;
}
</style>
